export default __webpack_public_path__ + "static/last_year_6-3120dc287ad92c7e1768cc9a9f3ebe67.webp";